import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{flexShrink:0}}>
    <circle cx="8" cy="8" r="8" fill="rgba(255,255,255,0.08)"/>
    <path d="M4.5 8L6.5 10L11.5 5.5" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const DashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{flexShrink:0}}>
    <circle cx="8" cy="8" r="8" fill="rgba(255,255,255,0.03)"/>
    <path d="M5 8H11" stroke="rgba(255,255,255,0.15)" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const plans = [
  {
    name: 'Free',
    tagline: 'Start exploring',
    price: 0,
    distance: '5 km',
    features: [
      { t: 'Live map — 5 km radius', ok: true },
      { t: '5 messages per day', ok: true },
      { t: 'Full profile + intentions', ok: true },
      { t: 'Filters by intention', ok: true },
      { t: 'Report & block users', ok: true },
      { t: 'Invisible mode', ok: false },
      { t: 'Unlimited messages', ok: false },
      { t: 'Larger map radius', ok: false },
    ],
    cta: 'Get started',
    action: 'signup',
    featured: false,
  },
  {
    name: 'Near+',
    tagline: 'For active users',
    price: 7.99,
    distance: '25 km',
    features: [
      { t: 'Live map — 25 km radius', ok: true },
      { t: 'Unlimited messages', ok: true },
      { t: 'Invisible mode', ok: true },
      { t: 'Advanced filters', ok: true },
      { t: 'Report & block users', ok: true },
      { t: 'Video calls in-app', ok: false },
      { t: 'Verified badge', ok: false },
      { t: 'Priority on map', ok: false },
    ],
    cta: 'Start Near+',
    action: 'plus',
    featured: true,
  },
  {
    name: 'Near Elite',
    tagline: 'No limits',
    price: 14.99,
    distance: 'Worldwide',
    features: [
      { t: 'Live map — worldwide', ok: true },
      { t: 'Unlimited messages', ok: true },
      { t: 'Invisible mode', ok: true },
      { t: 'Video calls in-app', ok: true },
      { t: 'Verified badge', ok: true },
      { t: 'Priority on map', ok: true },
      { t: 'Advanced filters', ok: true },
      { t: 'Priority support', ok: true },
    ],
    cta: 'Go Elite',
    action: 'elite',
    featured: false,
  },
];

export default function Pricing({ session }) {
  const navigate = useNavigate();
  const [billing, setBilling] = useState('monthly');
  const getPrice = (p) => billing === 'yearly' ? (p * 0.7).toFixed(2) : p.toFixed(2);

  return (
    <div style={{ background: '#080808', minHeight: '100vh' }}>
      {session && <Navbar session={session} />}
      <div style={{ maxWidth: '960px', margin: '0 auto', padding: session ? '90px 16px 60px' : '60px 16px 60px' }}>

        {!session && (
          <div onClick={() => navigate('/')} style={{ textAlign: 'center', marginBottom: '40px', cursor: 'pointer' }}>
            <span style={{ fontSize: '1.4rem', fontWeight: 700, color: 'white' }}>
              near<span style={{ color: 'rgba(255,255,255,0.3)' }}>me</span>
            </span>
          </div>
        )}

        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ fontSize: 'clamp(1.8rem,5vw,3rem)', fontWeight: 700, letterSpacing: '-2px', color: 'white', marginBottom: '10px' }}>
            Simple pricing.
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.95rem', marginBottom: '24px' }}>
            Free forever. Upgrade to expand your radius.
          </p>
          <div style={{ display: 'inline-flex', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '100px', padding: '4px', gap: '2px' }}>
            {[['monthly','Monthly'],['yearly','Yearly -30%']].map(([val,label]) => (
              <button key={val} onClick={() => setBilling(val)} style={{ padding: '8px 16px', background: billing===val ? 'white' : 'transparent', color: billing===val ? '#080808' : 'rgba(255,255,255,0.35)', border: 'none', borderRadius: '100px', fontSize: '0.82rem', fontWeight: billing===val ? 600 : 400, cursor: 'pointer' }}>
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Plans — stack vertical sur mobile */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '32px' }}>
          {plans.map(plan => (
            <div key={plan.name} style={{ background: plan.featured ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.02)', border: plan.featured ? '1px solid rgba(255,255,255,0.18)' : '1px solid rgba(255,255,255,0.06)', borderRadius: '20px', padding: '22px', position: 'relative' }}>
              {plan.featured && (
                <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', background: 'white', color: '#080808', fontSize: '10px', fontWeight: 700, padding: '4px 14px', borderRadius: '100px', whiteSpace: 'nowrap', letterSpacing: '0.5px' }}>
                  MOST POPULAR
                </div>
              )}

              {/* Header plan */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <span style={{ fontSize: '0.85rem', fontWeight: 700, color: 'white', textTransform: 'uppercase', letterSpacing: '1px' }}>{plan.name}</span>
                    <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.4)', background: 'rgba(255,255,255,0.06)', padding: '2px 9px', borderRadius: '100px' }}>{plan.distance}</span>
                  </div>
                  <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.25)' }}>{plan.tagline}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  {plan.price === 0 ? (
                    <div style={{ fontSize: '1.8rem', fontWeight: 700, color: 'white', letterSpacing: '-1px' }}>Free</div>
                  ) : (
                    <div>
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '3px', justifyContent: 'flex-end' }}>
                        <span style={{ fontSize: '1.8rem', fontWeight: 700, color: 'white', letterSpacing: '-1px' }}>{getPrice(plan.price)}€</span>
                        <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.78rem' }}>/mo</span>
                      </div>
                      {billing === 'yearly' && <div style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.4)' }}>{(plan.price*0.7*12).toFixed(0)}€/year</div>}
                    </div>
                  )}
                </div>
              </div>

              <div style={{ height: '1px', background: 'rgba(255,255,255,0.05)', marginBottom: '14px' }} />

              {/* Features en 2 colonnes sur mobile */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '7px', marginBottom: '18px' }}>
                {plan.features.map(f => (
                  <div key={f.t} style={{ display: 'flex', alignItems: 'flex-start', gap: '7px' }}>
                    {f.ok ? <CheckIcon /> : <DashIcon />}
                    <span style={{ fontSize: '0.78rem', color: f.ok ? 'rgba(255,255,255,0.8)' : 'rgba(255,255,255,0.18)', lineHeight: 1.4 }}>{f.t}</span>
                  </div>
                ))}
              </div>

              <button onClick={() => plan.action==='signup' ? navigate('/signup') : alert('Payment coming soon!')}
                style={{ width: '100%', padding: '13px', background: plan.featured ? 'white' : 'rgba(255,255,255,0.07)', color: plan.featured ? '#080808' : 'rgba(255,255,255,0.7)', border: plan.featured ? 'none' : '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer' }}>
                {plan.cta}
              </button>
            </div>
          ))}
        </div>

        {/* Women note */}
        <div style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', padding: '18px 20px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{ width: '38px', height: '38px', background: 'rgba(255,255,255,0.05)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="7" r="4" stroke="rgba(255,255,255,0.4)" strokeWidth="1.3"/><path d="M9 11V17M6.5 14.5H11.5" stroke="rgba(255,255,255,0.4)" strokeWidth="1.3" strokeLinecap="round"/></svg>
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: '0.85rem', color: 'white', marginBottom: '3px' }}>Full access — free for women</div>
            <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.78rem', lineHeight: 1.5 }}>Women get unlimited map radius at no cost.</div>
          </div>
        </div>

        {/* FAQ */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {[
            { q: 'Can I cancel anytime?', a: 'Yes, cancel anytime. No commitment.' },
            { q: 'Is Free really free?', a: 'Yes, forever. See people nearby and message them for free.' },
            { q: 'What does the radius limit mean?', a: 'Free = 5 km. Near+ = 25 km. Elite = worldwide.' },
            { q: 'Do women pay?', a: 'Women get full map access for free.' },
          ].map(f => (
            <div key={f.q} style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '14px', padding: '16px' }}>
              <div style={{ fontWeight: 600, fontSize: '0.85rem', color: 'white', marginBottom: '5px' }}>{f.q}</div>
              <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.8rem', lineHeight: 1.6 }}>{f.a}</div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
